import { useTranslation } from 'react-i18next';
import { ReactComponent as Logo } from '../../assets/images/logo.svg';
import downloadAndroid from '../../assets/images/downloadAndroid.png';
import downloadIos from '../../assets/images/downloadIos.png';
import { Link } from 'react-router-dom';
import { blogURL, getNamePathToPath } from '../../utils';
import { useState } from 'react';
import { useIsMobile } from '../../utils/hooks';
import { Drawer, Modal } from 'antd';
import { Plus, UploadIcon, XMarkSolid } from '../../utils/icons';
import { termsTypes, TermsTypes } from '../../views/Terms/index';

const memorialURL = 'https://the-memorial.org/';

const Footer = () => {
  const [showInstructionsToInstallOnIos, setShowInstructionsToInstallOnIos] =
    useState<boolean>(false);
  const isMobile = useIsMobile();
  const { t } = useTranslation();
  const links: { title: string; url: string }[] = [
    { title: t('footer.mission'), url: getNamePathToPath('mission') },
    { title: t('footer.blog'), url: blogURL },
    { title: t('footer.contactUs'), url: '/contact-us' },
    { title: t('footer.memorial'), url: memorialURL },
  ];

  const getInstructionsToInstallOnIos = () => (
    <ol className="m-0 pl-[20px]">
      <li className="mb-[16px]">
        <div className="flex justify-between">
          {t('footer.instructionsToInstallOnIos.step1')}{' '}
          <UploadIcon className="h-[22px] w-[22px] [&>path]:fill-info" />
        </div>
      </li>
      <li>
        <div className="flex justify-between">
          {t('footer.instructionsToInstallOnIos.step2')}
          <div className="flex h-[22px] w-[22px] items-center justify-center rounded-[4px] bg-text2">
            <Plus className="[&>path]:fill-text5" />
          </div>
        </div>
      </li>
    </ol>
  );

  return (
    <div className="bg-bg3 px-[60px] py-[24px] md:px-[90px] md:pb-[48px] md:pt-[60px]">
      {!isMobile && (
        <Modal
          title={t('footer.instructionsToInstallOnIos.title')}
          open={showInstructionsToInstallOnIos}
          onCancel={() => setShowInstructionsToInstallOnIos(false)}
          footer={null}
          closeIcon={<XMarkSolid />}
          centered
        >
          {getInstructionsToInstallOnIos()}
        </Modal>
      )}
      {isMobile && (
        <Drawer
          title={t('footer.instructionsToInstallOnIos.title')}
          placement="bottom"
          onClose={() => setShowInstructionsToInstallOnIos(false)}
          open={showInstructionsToInstallOnIos}
          closeIcon={<XMarkSolid />}
          rootClassName="drawerMobile"
        >
          {getInstructionsToInstallOnIos()}
        </Drawer>
      )}
      <div className="mb-[32px] flex flex-col justify-between md:flex-row">
        <div className="flex flex-1 flex-col md:flex-row">
          <Logo className="min-w-[126px]" />
          <p className="mt-[8px] max-w-[284px] text-text2 md:ml-[16px] md:mt-0">
            {t('footer.infoText')}
          </p>
        </div>
        <div className="mt-[32px] flex flex-1 flex-col md:mt-0">
          <div className="flex flex-col gap-[8px] md:flex-row md:flex-wrap md:justify-end">
            {links.map((e, i) => (
              <Link
                to={e.url}
                key={`footer-link-${i}`}
                className="px-[4px]"
                target={e.url === memorialURL || e.url === blogURL ? '_blank' : undefined}
              >
                {e.title}
              </Link>
            ))}
            {termsTypes.map((type: TermsTypes) => (
              <Link
                key={type}
                to={`${getNamePathToPath('terms', { termType: type })}`}
                target="blank"
                className="px-[4px]"
              >
                {t(`footer.${type}`)}
              </Link>
            ))}
          </div>
          <div className="mt-[40px] flex justify-end gap-[8px] md:mt-[16px]">
            <Link
              to="https://play.google.com/store/apps/details?id=com.google.android.youtube.tv&hl=es_CO&gl=US"
              className="max-h-[40px]"
              target="blank"
            >
              <img src={downloadAndroid} alt="" className="cursor-pointer" />
            </Link>
            <img
              src={downloadIos}
              alt=""
              className="cursor-pointer"
              onClick={() => setShowInstructionsToInstallOnIos(true)}
            />
          </div>
        </div>
      </div>
      <p className="mb-[24px] mt-[48px] text-center text-text2 md:mb-0 md:mt-[32px]">
        {t('footer.newLineInternational')}
      </p>
    </div>
  );
};

export default Footer;
